import React, { useContext } from 'react';
import { Alert, Row, Col, Card } from 'antd';
import { Context } from '../../../../../defaults';

const Question4 = ({ data }) => {
    const { dictionary, language, setLoading } = useContext(Context);

    return (
        <div>
            <Card title={dictionary?.StudentAnswer[language]}>
                <ul>
                    {
                        data.studentAnswer.answerVariants.map(el => {
                            return <li key={`studentAns${el.id}`} style={{ textAlign: 'left', padding: 20, backgroundColor: '#F5F5F5', marginTop: '20px' }}>
                                {
                                    el.answerText &&
                                    <p>{el.answerText}</p>
                                }
                            </li>
                        })
                    }
                </ul>
            </Card>
            <Card title={dictionary?.RightAnswer[language]} style={{ marginTop: 30 }}>
                <ul>
                    {
                        data.question.answerVariants.map(el => {
                            return <li key={`rightAns${el.id}`} style={{ textAlign: 'left', padding: 20, backgroundColor: '#F5F5F5', marginTop: '20px' }}>
                                {
                                    el.answerText &&
                                    <p>{el.answerText}</p>
                                }
                                {
                                    el.answerHtml &&
                                    <p style={{ wordWrap: 'break-word' }} dangerouslySetInnerHTML={{ __html: el.answerHtml }} />
                                }
                            </li>
                        })
                    }
                </ul>
            </Card>
            {/* <div style={{ marginTop: 30 }}>
                <Alert message={data.studentAnswer.isRight === 1 ? dictionary?.RightAnswer[language] : dictionary?.NotRightAnswer[language]} type={data.studentAnswer.isRight === 1 ? 'success' : 'error'} showIcon />
            </div> */}
        </div>
    );
}

export default Question4;